import type { BooleanSettingKey, Setting } from '../../../context/settings-context';
import { useSettings, useUpdateSettings } from '../../../context/settings-context';

export function useSettingToggle<K extends BooleanSettingKey>(key: K, fallback: boolean) {
  const settings = useSettings();
  const { mutate } = useUpdateSettings();
  return {
    checked: settings[key] ?? fallback,
    onChange: (value: boolean) => mutate({ key, value } as Setting),
  };
}
